import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Tile from "../Tile/Tile";
import Video from "../Video/Video";
import { IconVideoPlay64 } from "../Icons/Icons";

import "./video-tile.scss";

class VideoTile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showVideoModal: false,
    };

    this.handleModalVisibitily = this.handleModalVisibitily.bind(this);
  }

  handleModalVisibitily(show) {
    this.setState({
      showVideoModal: show,
    });
  }

  render() {
    const { label, heading, backgroundImages, url, children, className } = this.props;
    const classes = classNames("video-tile", "video-trigger", className);
    const { showVideoModal } = this.state;

    return (
      <Tile
        label={
          <span>
            {label} <IconVideoPlay64 className="video-tile__play-icon" />
          </span>
        }
        heading={heading}
        onClick={() => {
          this.handleModalVisibitily(true);
        }}
        className={classes}
        backgroundImages={backgroundImages}
      >
        <Video
          url={url}
          inModal
          showModal={showVideoModal}
          handleCloseModal={e => {
            e.stopPropagation();
            this.handleModalVisibitily(false);
          }}
        />
        {children}
      </Tile>
    );
  }
}

VideoTile.propTypes = {
  /**
   * Component main title
   */
  heading: PropTypes.string.isRequired,
  /**
   * Label showing on top of the title
   */
  label: PropTypes.string,
  /**
   * Background image source
   */
  backgroundImages: PropTypes.string,
  /**
   * Video url (youtube | vimeo accepted)
   */
  url: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
};

export default VideoTile;
